import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router/index'
import i18n from './lang' // Internationalization
import Cookies from 'js-cookie'

import ElementUI from "element-ui";
// import "element-ui/lib/theme-chalk/index.css";
import "../src/style/element-#5474E6/index.css";
import "../util/flexible";
import "../src/style/index.css";
import '../util/otherRenders'


import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import popup from "@/components/tui-popup/popup.js";
Vue.prototype.$popup = popup.install;

import formCreate from '@form-create/element-ui'
import FcDesigner from '@form-create/designer'

import Toolbar from './components/Toolbar.vue'
Vue.component('Toolbar', Toolbar)

import QuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.bubble.css'
import 'quill/dist/quill.snow.css'
Vue.use(QuillEditor)

Vue.use(formCreate)
Vue.use(FcDesigner)
ElementUI.Dialog.props.closeOnClickModal.default = false;
Vue.use(ElementUI, {
    size: Cookies.get('size') || 'medium', // set element-ui default size
    i18n: (key, value) => i18n.t(key, value)
});


import 'font-awesome/css/font-awesome.min.css'
const whiteList = ['/login', '/hxlogin']
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    let Token = window.localStorage.getItem("Token")
    if (Token) {
        if (to.path == '/login') {
            next({
                path: '/login'
            })
        } else if (to.path == '/hxlogin') {
            next({
                path: '/hxlogin'
            })
        } else {
            next()
        }
    } else {
        if (whiteList.includes(to.path)) {
            next()
        } else {
            if (to.path == '/login') {
                next({
                    path: '/login'
                })
            } else if (to.path == '/hxlogin') {
                next({
                    path: '/hxlogin'
                })
            } else {
                next()

            }
        }
    }
})


Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
import "./promissionRouter"; //添加从后台获取的路由